<template>
    <ContentOrLoading>
        <div v-if="!loading">
            <div class="text-right mb-4">
                <Button @click.prevent="guardarPrecios(butacas)">Guardar todos</Button>
            </div>
            <template v-for="(butaca, index) in butacas">
                <div class="row mb-4" :key="index">
                    <div class="col-7 col-md-10">
                        <div class="row">
                            <div class="col-12 col-md-2">
                                <strong v-if="butaca.sector_name">{{ butaca.sector_name }}<br/></strong>
                                <small>Fila: {{ butaca.fila }} - Butaca: {{ butaca.butaca }}</small>
                            </div>
                            <div class="col-12 col-md-4">
                                <multiselect
                                    v-model="butaca.precios_taquilla"
                                    placeholder="Precios taquilla"
                                    :custom-label="customLabel"
                                    label="label_con_gd"
                                    track-by="id"
                                    :options="tipos.data"
                                    :multiple="true"
                                    :show-labels="false"
                                    @select="change($event, index, true)"
                                />
                            </div>
                            <div class="col-12 col-md-4">
                                <multiselect
                                    v-model="butaca.precios_online"
                                    placeholder="Precios online"
                                    :custom-label="customLabel"
                                    label="label_sin_gd"
                                    track-by="id"
                                    :options="tipos.data"
                                    :multiple="true"
                                    :show-labels="false"
                                    @select="change($event, index, false)"
                                />
                            </div>
                        </div>
                    </div>
    
                    <div class="col-5 col-md-2 text-right">
                        <Button @click.prevent="guardarPrecios([butaca])">Guardar</Button>
                    </div>
                </div>
            </template>
        </div>
    </ContentOrLoading>
</template>

<script>
    export default {
        props: ['tipos', 'recinto_id', 'butacas'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            change(selectedOption, index, taquilla) {
                if (!this.ambos) return

                const butaca = this.butacas[index]
                const precios = taquilla
                    ? butaca.precios_online
                    : butaca.precios_taquilla

                precios.push(selectedOption)
            },
            guardarPrecios(butacas) {
                this.loading = true;

                var butacas_formatted = [];
                for (var i in butacas) {
                    var precios_online = []
                    var precios_taquilla = []

                    for (var x in butacas[i].precios_online) {
                        precios_online.push(butacas[i].precios_online[x].id)
                    }

                    for (var z in butacas[i].precios_taquilla) {
                        precios_taquilla.push(butacas[i].precios_taquilla[z].id)
                    }

                    butacas_formatted.push({
                        id: butacas[i].id,
                        precios_online: precios_online,
                        precios_taquilla: precios_taquilla,
                    });
                }

                const params = {
                    filters : {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: this.recinto_id,
                    butacas: butacas_formatted
                }

                this.$store.dispatch(this.config.getVuexAlias('back.lista.settings.recinto.butacas.guardar.precios'), params).then(res => {
                    this.$emit('getButacas');
                }).finally(() => this.loading = false);
            },
            customLabel({ descripcion, renovacion }) {
                if(renovacion) {
                    return '(Renovación) - ' + `${descripcion}`;
                }

                return `${descripcion}`
            },
        }
    }
</script>
